/*
    Author:
    Date: 2018/11/29
    Usage: Render Layout Menu
    Parent: ./twmsMaterial.jsx, none
    Childern: none, none
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setSidebarItems, setMobileMenuExpanded, setDrawerOpen, setActiveTaskId, } from 'reducers/Layout/action';
import { getSidebarItems, getMobileMenuExpanded, getUserMenuLayouts, getDrawerOpen, getActiveTaskId, } from 'reducers/Layout/selector';
import { getUserDataRedux } from 'reducers/Login/selector';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Hidden from '@material-ui/core/Hidden';
import { withStyles } from '@material-ui/core/styles';
import MobileMenuSidebar from './MobileMenuSidebar';
var StyledAppBar = withStyles({
// root: { zIndex: 50 }
})(AppBar);
var StyledTab0 = withStyles({
    root: {
        color: '#072c82',
        fontWeight: 'bold',
        fontSize: '1.3rem',
        fontFamily: 'NotoSansTC',
        borderLeft: '1px solid rgba(7,44,130,.15)',
        borderRight: '1px solid rgba(7,44,130,.15)',
        minHeight: 'initial',
        '&:hover': { color: '#0086da' },
    },
    selected: {
        background: '-webkit-linear-gradient(top,#20a4ef,#1997e3)',
        color: 'white',
        fontWeight: 'initial',
        '&:hover': {
            color: 'white',
            fontWeight: 'bold',
        },
    },
})(Tab);
var StyledTab = withStyles({
    root: {
        color: '#072c82',
        fontWeight: 'bold',
        fontSize: '1.3rem',
        fontFamily: 'NotoSansTC',
        borderRight: '1px solid rgba(7,44,130,.15)',
        minHeight: 'initial',
        '&:hover': { color: '#0086da' },
    },
    selected: {
        background: '-webkit-linear-gradient(top,#20a4ef,#1997e3)',
        color: 'white',
        fontWeight: 'initial',
        '&:hover': {
            color: 'white',
            fontWeight: 'bold',
        },
    },
})(Tab);
var StyledTabs = withStyles({
    root: {
        color: 'rgba(0, 0, 0, 0.87)',
        background: '-webkit-linear-gradient(top,#fff,#e7f5fe)',
        minHeight: 'initial',
    },
})(Tabs);
var ForEffect = function (props) {
    var actions = props.actions, urlPath = props.urlPath, userMenuLayout = props.userMenuLayout;
    useEffect(function () {
        // setTabIndex ---------------
        var pathnameArray = urlPath.split('/');
        var codeId = pathnameArray[pathnameArray.length - 2];
        if (codeId) {
            var tabIdx = userMenuLayout.findIndex(function (obj) { return obj.codeId === codeId.toUpperCase(); });
            if (tabIdx > -1)
                actions.setSidebarItems(userMenuLayout[tabIdx].children);
        }
    }, [urlPath, userMenuLayout]);
    return React.createElement(React.Fragment, null);
};
var MenuShow = /** @class */ (function (_super) {
    __extends(MenuShow, _super);
    function MenuShow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /*
              Usage: Change sidebarlistItem Content
              Param: 點擊的Item名稱
          */
        _this.handleChange = function () { return function (event, value) {
            var _a = _this.props, actions = _a.actions, userMenuLayouts = _a.userMenuLayouts;
            actions.setSidebarItems(userMenuLayouts[value].children);
            actions.setActiveTaskId('');
        }; };
        /*
              Usage: 改變Mobile Sidebarlist的展開狀態
              Param: 展開狀態
          */
        _this.handleMobileChange = function () { return function (event, expanded) {
            var actions = _this.props.actions;
            actions.setSidebarlistMobilemenuexpanded(expanded);
        }; };
        /*
              Usage: 改變Sidebarlist的開啟狀態
              Param: none
          */
        _this.handleClick = function () {
            var _a = _this.props, actions = _a.actions, drawerOpen = _a.drawerOpen;
            actions.setSidebarlistOpen(drawerOpen);
        };
        _this.handleDrawerClose = function () {
            // console.log("drawerClose");
            var _a = _this.props, actions = _a.actions, drawerOpen = _a.drawerOpen;
            actions.setDrawerOpen(drawerOpen);
        };
        _this.handleDrawerClick = function (taskId) { return function () {
            // this.handleItemClick(taskId, taskName);
            _this.handleItemClick(taskId);
            _this.handleDrawerClose();
        }; };
        _this.handleItemClick = function (taskId) { return function () {
            // LogWrite(this.props.jwtData, this.props.userId, taskId, "使用" + taskName)
            var actions = _this.props.actions;
            window.sessionStorage.setItem('userUsingTask', taskId);
            actions.setActiveTaskId(taskId);
        }; };
        return _this;
    }
    MenuShow.prototype.render = function () {
        var _a = this.props, actions = _a.actions, urlPath = _a.urlPath, userMenuLayout = _a.userMenuLayouts, sidebarItems = _a.sidebarItems, drawerOpen = _a.drawerOpen, mobileMenuExpanded = _a.mobileMenuExpanded, activeTaskId = _a.activeTaskId;
        var tabValue = userMenuLayout.findIndex(function (obj) { return obj.children === sidebarItems; });
        return (React.createElement(React.Fragment, null,
            React.createElement(ForEffect, { actions: actions, urlPath: urlPath, userMenuLayout: userMenuLayout }),
            React.createElement(Hidden, { smDown: true },
                React.createElement(StyledAppBar, { position: "static", className: "" },
                    React.createElement(StyledTabs, { onChange: this.handleChange(), value: tabValue === -1 ? 0 : tabValue, indicatorColor: "primary", 
                        // variant="scrollable"  // 造成 centered 失效，數量過多再改
                        scrollButtons: "auto", centered: true }, userMenuLayout.map(function (prop, idx) {
                        return idx === 0 ? (React.createElement(StyledTab0, { label: prop.taskName, value: idx, key: prop.menuId })) : (React.createElement(StyledTab, { label: prop.taskName, value: idx, key: prop.menuId }));
                    })))),
            React.createElement(Hidden, { mdUp: true },
                React.createElement(MobileMenuSidebar, { sidebarOpen: drawerOpen, handleDrawerClose: this.handleDrawerClose, userMenuLayoutData: userMenuLayout, mobileMenuExpanded: mobileMenuExpanded, handleMobileChange: this.handleMobileChange, activeTaskId: activeTaskId, handleDrawerClick: this.handleDrawerClick }))));
    };
    return MenuShow;
}(React.Component));
var mapStateToProps = function (state) { return ({
    sidebarItems: getSidebarItems(state),
    drawerOpen: getDrawerOpen(state),
    mobileMenuExpanded: getMobileMenuExpanded(state),
    userMenuLayouts: getUserMenuLayouts(state),
    userId: getUserDataRedux(state).userId,
    activeTaskId: getActiveTaskId(state),
}); };
var mapDispatchToProps = function (dispatch) {
    var actions = {
        setSidebarItems: setSidebarItems,
        setMobileMenuExpanded: setMobileMenuExpanded,
        setDrawerOpen: setDrawerOpen,
        setActiveTaskId: setActiveTaskId,
    };
    return {
        actions: bindActionCreators(actions, dispatch),
        dispatch: dispatch,
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(MenuShow);
